import { createGlobalStyle } from 'styled-components'
import global from 'styles/global'
import type { GlobalStyleComponent, DefaultTheme } from 'styled-components'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GlobalStyles: GlobalStyleComponent<any, DefaultTheme> =
  createGlobalStyle`
  ${global}
`

export default GlobalStyles
